import { decode as _decodeHtml } from "html-entities";
const decodeHtml = _decodeHtml;

/*
    Single source of truth for "how long is this caption line".

    Rule (what a viewer sees on one line):
      - tags are not counted, entities count as the character they encode
      - &nbsp; counts as a normal space
      - a run of spaces counts as one space
      - leading and trailing spaces on a line are not counted
      - a space before "." or "," is not counted (unless it follows "-")

    getPlainLines/getLineLengths work on Quill HTML strings (no DOM needed, used by QC and auto format).
    getCountedMask works on the raw textContent of one <p> so DOM code (excess-character highlight)
    can find the exact character that crosses the limit using the same rule.
*/

const isCollapsibleSpace = ch => ch === " " || ch === " ";
function normalizeLine(line) {
  return line.replace(/ /g, " ").replace(/ +/g, " ").replace(/(?<!-) ([.,])/g, "$1").trim();
}
function getPlainLines(html) {
  if (!html) {
    return [];
  }
  let text = String(html).replace(/<rt\b[^>]*>[\s\S]*?<\/rt>/gi, "").replace(/<\/p>/gi, "\n").replace(/<[^>]*>/g, "");
  text = decodeHtml(text).trim();
  if (!text) {
    return [];
  }
  return text.split("\n").map(normalizeLine);
}
function getLineLengths(html) {
  return getPlainLines(html).map(line => line.length);
}
function getMaxLineLength(html) {
  return getLineLengths(html).reduce((max, len) => Math.max(max, len), 0);
}

/**
 * For the raw text of one line, mark which UTF-16 code units are counted by the rule above.
 * The number of true entries always equals normalizeLine(raw).length.
 * @param {string} raw
 * @returns {boolean[]}
 */
function getCountedMask(raw) {
  const text = raw || "";
  const n = text.length;
  const mask = new Array(n).fill(true);
  let start = 0;
  while (start < n && /\s/.test(text[start])) {
    mask[start] = false;
    start++;
  }
  let end = n - 1;
  while (end >= start && /\s/.test(text[end])) {
    mask[end] = false;
    end--;
  }
  for (let i = start; i <= end; i++) {
    if (!isCollapsibleSpace(text[i])) {
      continue;
    }
    if (isCollapsibleSpace(text[i - 1])) {
      mask[i] = false;
      continue;
    }
    let next = i + 1;
    while (next <= end && isCollapsibleSpace(text[next])) {
      next++;
    }
    if ((text[next] === "." || text[next] === ",") && text[i - 1] !== "-") {
      mask[i] = false;
    }
  }
  return mask;
}
export default {
  getPlainLines,
  getLineLengths,
  getMaxLineLength,
  getCountedMask,
  normalizeLine
};